import { render, staticRenderFns } from "./FreightTableSupplierSection.vue?vue&type=template&id=72346f16&scoped=true"
import script from "./FreightTableSupplierSection.vue?vue&type=script&lang=js"
export * from "./FreightTableSupplierSection.vue?vue&type=script&lang=js"
import style0 from "./FreightTableSupplierSection.vue?vue&type=style&index=0&id=72346f16&prod&scoped=true&lang=less"
import style1 from "./FreightTableSupplierSection.vue?vue&type=style&index=1&id=72346f16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72346f16",
  null
  
)

export default component.exports